import { ref } from 'vue'

// Estado compartido entre todos los componentes que usen este composable
const syncingCasos = ref(false)
const syncCasosError = ref(null)
const syncCasosResult = ref(null)

export function useCasosSync() {
    /**
     * Dispara un re-sync de casos en el servidor envivo.
     * El servidor frontendhistorias actúa como proxy para no exponer credenciales al navegador.
     * Es fire-and-forget: no bloquea el flujo del llamador, los errores se loguean en consola.
     */
    async function syncCasos(serverName) {
        syncingCasos.value = true
        syncCasosError.value = null
        syncCasosResult.value = null

        try {
            const response = await fetch(`/api/${serverName}/casos/sync`, {
                method: 'POST',
                credentials: 'include',
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.error || 'Error al sincronizar con envivo')
            }

            syncCasosResult.value = data
            console.log(`✅ Envivo sync: ${data.synced} casos sincronizados en el servidor ${serverName}`)
        } catch (err) {
            syncCasosError.value = err.message
            console.error('Error sincronizando casos con envivo:', err)
        } finally {
            syncingCasos.value = false
        }
    }

    return { syncingCasos, syncCasosError, syncCasosResult, syncCasos }
}